var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { View } from '@amzn/atoz-web/View';
import { DetailedCheckbox } from '@amzn/atoz-web/DetailedCheckbox';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { areDatesEqual, timeDifferenceWithDurationString } from '@amzn/atoz-shiftapp-utilities';
import { logger } from '@amzn/atoz-shiftapp-metrics';
export var SwapRequestListLegacy = function (_a) {
    var swapToDates = _a.swapToDates, originalShiftStart = _a.originalShiftStart, originalShiftEnd = _a.originalShiftEnd, toggleAction = _a.toggleAction, handleClick = _a.handleClick, closeAction = _a.closeAction, _b = _a.selectedDates, selectedDates = _b === void 0 ? [] : _b, validationError = _a.validationError, _c = _a.multipleShifts, multipleShifts = _c === void 0 ? false : _c;
    var t = useTranslation().t;
    // Request will be invalid if there are no dates to swap to or no original shift to swap from
    var isInvalidRequest = !(swapToDates === null || swapToDates === void 0 ? void 0 : swapToDates.length) || !originalShiftStart;
    var originalShiftDate = DateTime.fromISO(originalShiftStart);
    if (isInvalidRequest) {
        logger.emitError('Swap request object cannot be created due to invalid request parameters');
        return null;
    }
    return (React.createElement(ModalContent, { dataTestId: "SwapRequestListLegacy", onCloseButtonClick: closeAction, titleText: t('shift_mangement_features_SwapRequestList_title'), closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(Col, { gridGap: "S300" },
            multipleShifts && (React.createElement(MessageBanner, { dataTestId: "SwapRequestListMultipleShiftBanner", type: MessageBannerType.Informational },
                React.createElement(Text, null,
                    t('shift_management_features_customSwap_banner'),
                    React.createElement("strong", null, " ".concat(originalShiftDate.weekdayShort, " ").concat(originalShiftDate.monthShort, " ").concat(originalShiftDate.day, "."))))),
            React.createElement(ValidationContainer, { showBanner: validationError, "data-testid": "SwapRequestListValidation", "aria-hidden": !validationError },
                React.createElement(MessageBanner, { type: MessageBannerType.Error },
                    React.createElement(Text, null, t('shift_mangement_features_SwapRequestList_validationBanner')))),
            React.createElement(CheckboxRow, null, swapToDates.map(function (date) {
                if (!date.isValid) {
                    logger.emitError('Invalid SwapTo date', {
                        context: { date: date }
                    });
                    return null;
                }
                var selected = selectedDates.find(function (current) {
                    return current.isValid && areDatesEqual(current, date);
                })
                    ? true
                    : false;
                return (React.createElement(CheckboxContainer, { dataTestId: "swapRequestOption", key: "swap-request-option-".concat(date.toISO()) },
                    React.createElement(DetailedCheckbox, { titleText: date.toLocaleString({
                            month: 'short',
                            day: 'numeric'
                        }), details: date.toLocaleString({
                            weekday: 'short'
                        }), checked: selected, onChange: function () { return toggleAction(date); }, error: validationError })));
            })),
            React.createElement(Text, { fontSize: "T400", fontWeight: "medium" }, t('shift_mangement_features_SwapRequestList_originalShiftSubtitle')),
            React.createElement(Text, { dataTestId: "originalShiftString", lineHeight: 0.5 }, DateTime.fromISO(originalShiftStart).toLocaleString({
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            })),
            React.createElement(View, { backgroundColor: "neutral05", padding: ['S300'], margin: { top: 'S100' } },
                React.createElement(Text, { dataTestId: "originalShiftDurationString", fontWeight: "medium" }, timeDifferenceWithDurationString(DateTime.fromISO(originalShiftStart), DateTime.fromISO(originalShiftEnd)))),
            React.createElement(Text, { fontSize: "T300" }, t('shift_mangement_features_SwapRequestList_body')),
            React.createElement(Button, { variant: ButtonVariant.Primary, dataTestId: "SwapRequestListConfirm", onClick: handleClick }, t('shift_mangement_features_SwapRequestList_confirm')))));
};
var CheckboxRow = styledWithTheme(Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-wrap: wrap;\n    margin: 0 -0.5rem;\n"], ["\n    flex-wrap: wrap;\n    margin: 0 -0.5rem;\n"])));
var CheckboxContainer = styledWithTheme(View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 0 1 calc(50% - 1rem);\n    margin: 0.5rem;\n"], ["\n    flex: 0 1 calc(50% - 1rem);\n    margin: 0.5rem;\n"])));
var ValidationContainer = styledWithTheme('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var showBanner = _a.showBanner;
    return "\n        visibility: ".concat(showBanner ? 'visible' : 'hidden', ";\n        display: ").concat(showBanner ? 'block' : 'none', ";\n    ");
});
var templateObject_1, templateObject_2, templateObject_3;
